import React from "react";
import { alpha, Box, Typography, useMediaQuery, useTheme } from "@mui/material";

const LabeledIconCard = ({ icon, title, value, color }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 2,
        border: `1px solid ${alpha(color, 0.2)}`,
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: alpha(color, 0.12),
          transform: "translateY(-2px)",
          boxShadow: `0 4px 12px ${alpha(color, 0.15)}`,
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        {!isMobile && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 36,
              height: 36,
              borderRadius: "50%",
              backgroundColor: alpha(color, 0.15),
              color: color,
              mr: 2,
            }}
          >
            {icon}
          </Box>
        )}
        <Typography
          variant="body2"
          fontWeight={500}
          sx={{ color: theme.palette.text.primary }}
        >
          {title}
        </Typography>
      </Box>

      <Typography
        variant="h4"
        align="center"
        fontWeight={700}
        sx={{
          color,
          mt: 1,
          fontSize: {
            xs: "1rem",
            sm: "1.2rem",
            md: "1.2rem",
          },
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default LabeledIconCard;
